"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chip = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("../../core");
var _Icon = _interopRequireDefault(require("../../core/Icon/Icon"));
var _utils = require("../../system/utils");
var _excluded = ["text", "textColor", "size", "leftIcon", "rightIcon", "hasBorder", "borderColor", "backgroundColor", "flexDirection", "height", "disabled"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_d1y7tlokk() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Chip/Chip.tsx";
  var hash = "f871707437314a82acb630ca263371e8eb5e13bb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Chip/Chip.tsx",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 55
        },
        end: {
          line: 85,
          column: 1
        }
      },
      "1": {
        start: {
          line: 36,
          column: 17
        },
        end: {
          line: 44,
          column: 4
        }
      },
      "2": {
        start: {
          line: 46,
          column: 51
        },
        end: {
          line: 51,
          column: 3
        }
      },
      "3": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 83,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 22,
            column: 55
          },
          end: {
            line: 22,
            column: 56
          }
        },
        loc: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 35
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 25,
            column: 9
          },
          end: {
            line: 25,
            column: 16
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 2
          },
          end: {
            line: 28,
            column: 18
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 28,
            column: 14
          },
          end: {
            line: 28,
            column: 18
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 29
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 29,
            column: 16
          },
          end: {
            line: 29,
            column: 29
          }
        }],
        line: 29
      },
      "3": {
        loc: {
          start: {
            line: 56,
            column: 9
          },
          end: {
            line: 62,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 9
          },
          end: {
            line: 56,
            column: 17
          }
        }, {
          start: {
            line: 57,
            column: 10
          },
          end: {
            line: 61,
            column: 12
          }
        }],
        line: 56
      },
      "4": {
        loc: {
          start: {
            line: 60,
            column: 19
          },
          end: {
            line: 60,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 60,
            column: 30
          },
          end: {
            line: 60,
            column: 42
          }
        }, {
          start: {
            line: 60,
            column: 45
          },
          end: {
            line: 60,
            column: 59
          }
        }],
        line: 60
      },
      "5": {
        loc: {
          start: {
            line: 64,
            column: 9
          },
          end: {
            line: 74,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 9
          },
          end: {
            line: 64,
            column: 13
          }
        }, {
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 73,
            column: 17
          }
        }],
        line: 64
      },
      "6": {
        loc: {
          start: {
            line: 69,
            column: 23
          },
          end: {
            line: 69,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 48
          },
          end: {
            line: 69,
            column: 49
          }
        }, {
          start: {
            line: 69,
            column: 52
          },
          end: {
            line: 69,
            column: 56
          }
        }],
        line: 69
      },
      "7": {
        loc: {
          start: {
            line: 69,
            column: 62
          },
          end: {
            line: 69,
            column: 96
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 88
          },
          end: {
            line: 69,
            column: 89
          }
        }, {
          start: {
            line: 69,
            column: 92
          },
          end: {
            line: 69,
            column: 96
          }
        }],
        line: 69
      },
      "8": {
        loc: {
          start: {
            line: 75,
            column: 9
          },
          end: {
            line: 81,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 9
          },
          end: {
            line: 75,
            column: 18
          }
        }, {
          start: {
            line: 76,
            column: 10
          },
          end: {
            line: 80,
            column: 12
          }
        }],
        line: 75
      },
      "9": {
        loc: {
          start: {
            line: 79,
            column: 19
          },
          end: {
            line: 79,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 79,
            column: 30
          },
          end: {
            line: 79,
            column: 42
          }
        }, {
          start: {
            line: 79,
            column: 45
          },
          end: {
            line: 79,
            column: 60
          }
        }],
        line: 79
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f871707437314a82acb630ca263371e8eb5e13bb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_d1y7tlokk = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_d1y7tlokk();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/** Chip renders a flex box with text and icon */
cov_d1y7tlokk().s[0]++;
var Chip = exports.Chip = function Chip(_ref) {
  var text = _ref.text,
    textColor = _ref.textColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? (cov_d1y7tlokk().b[0][0]++, 'small') : _ref$size,
    leftIcon = _ref.leftIcon,
    rightIcon = _ref.rightIcon,
    _ref$hasBorder = _ref.hasBorder,
    hasBorder = _ref$hasBorder === void 0 ? (cov_d1y7tlokk().b[1][0]++, true) : _ref$hasBorder,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? (cov_d1y7tlokk().b[2][0]++, 'neutrals100') : _ref$borderColor,
    backgroundColor = _ref.backgroundColor,
    flexDirection = _ref.flexDirection,
    height = _ref.height,
    disabled = _ref.disabled,
    marginProps = _objectWithoutProperties(_ref, _excluded);
  cov_d1y7tlokk().f[0]++;
  var styles = (cov_d1y7tlokk().s[1]++, (0, _utils.useMultiStyleConfig)('Chip', {
    size: size,
    disabled: disabled,
    backgroundColor: backgroundColor,
    hasBorder: hasBorder,
    borderColor: borderColor,
    flexDirection: flexDirection,
    textColor: textColor
  }));
  // Size of icon is pre-determined based on chip size
  var sizeMap = (cov_d1y7tlokk().s[2]++, {
    small: 12,
    medium: 16,
    large: 24,
    'extra-large': 24
  });
  {
    cov_d1y7tlokk().s[3]++;
    return /*#__PURE__*/_react["default"].createElement(_core.Flex, _extends({
      "data-testid": "chip-component",
      __css: _objectSpread({}, styles.container)
    }, marginProps), (cov_d1y7tlokk().b[3][0]++, leftIcon) && (cov_d1y7tlokk().b[3][1]++, /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({}, leftIcon, {
      size: sizeMap[size],
      color: disabled ? (cov_d1y7tlokk().b[4][0]++, 'neutrals70') : (cov_d1y7tlokk().b[4][1]++, leftIcon.color)
    }))), (cov_d1y7tlokk().b[5][0]++, text) && (cov_d1y7tlokk().b[5][1]++, /*#__PURE__*/_react["default"].createElement(_core.Text, {
      "data-testid": "badge-text",
      __css: _objectSpread(_objectSpread({}, styles.label), {
        pl: leftIcon !== undefined ? (cov_d1y7tlokk().b[6][0]++, 3) : (cov_d1y7tlokk().b[6][1]++, null),
        pr: rightIcon !== undefined ? (cov_d1y7tlokk().b[7][0]++, 3) : (cov_d1y7tlokk().b[7][1]++, null)
      })
    }, text)), (cov_d1y7tlokk().b[8][0]++, rightIcon) && (cov_d1y7tlokk().b[8][1]++, /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({}, rightIcon, {
      size: sizeMap[size],
      color: disabled ? (cov_d1y7tlokk().b[9][0]++, 'neutrals70') : (cov_d1y7tlokk().b[9][1]++, rightIcon.color)
    }))));
  }
};